export default "__VITE_ASSET__iIs0$LzU__"